export default "__VITE_ASSET__6e592c33__"